import { ImageMeta } from './imageMeta'

export class AreaOfDamageImage extends ImageMeta {
  /**
     * Class representing an area of damage image
     * @param {Object} options - the data of the area of damage image
     * @param {Number} selectVal - id of the selected damage type
     *
     */
  constructor (options) {
    if (options) {
      super(options)
      this.selectVal = options.selectVal
    } else {
      super()
    }
  }

  get selectVal () {
    return this._selectVal
  }

  set selectVal (value) {
    if (value) this._selectVal = Number(value)
    else this._selectVal = null
  }
}
